<template>
  <main id="invoices-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('invoices.list.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <!-- Above the results and outside the dialog on purpose: the run outlives the dialog that
           started it, and whoever opens this screen later should still see it. -->
      <background-process-progress :process-name="pdfToSageProcessName" />


      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <div :span="5" v-if="!isInBulkPrintingInvoices && !isInUploadToVersapay" class="default-section-title">
              {{ $t('invoices.list.summaryTitle') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </div>
            <el-col :span="12" v-if="!isInBulkPrintingInvoices && !isInUploadToVersapay" class="default-section-title totals-section">
               <el-row class="default-section-header-totals">
                  <span v-if="invoices.total > 0" class="invoice-total">
                    <template>
                      <span>{{ `${$t('invoices.list.totalInvoices')}:` }}</span>  {{ invoices.total }}
                    </template>
                  </span>
                  <span v-if="invoices.total > 0" class="invoice-total total-amount">
                    <template >
                      <span>{{ `${$t('invoices.list.totalAmount')}:` }}</span> {{ getTotalAmount(invoices) }}
                    </template>
                  </span>
                  <span v-if="invoices.total > 0" class="invoice-total">
                    <template>
                      <span>{{ `${$t('invoices.list.totalUnits')}:` }}</span> {{ invoices.totalUnits }}
                    </template>
                  </span>
                  <span v-if="invoices.total > 0" class="invoice-total">
                    <template>
                      <span>{{ `${$t('invoices.list.totalCubes')}:` }}</span> {{ invoices.totalCubes }}
                    </template>
                  </span>
               </el-row>
            </el-col>
            <el-col :span="6" v-if="isInBulkPrintingInvoices" class="default-section-title">
              <div class="single-title"> {{ $t('invoices.list.selectInvoicesToPrint') }} </div>
            </el-col>
            <el-col :span="6" v-if="isInUploadToVersapay" class="default-section-title">
              <div class="single-title"> {{ $t('invoices.list.selectInvoicesToUploadToVersapay') }} </div>
            </el-col>
            <div class="default-section-actions text-align-end">
              <add-manual-invoice-dialog v-if="!isInBulkPrintingInvoices && !isInUploadToVersapay" />
              <more-actions/>
            </div>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import AddManualInvoiceDialog from './components/AddManualInvoiceDialog';
import MoreActions from './components/MoreActions';
import BackgroundProcessProgress from './components/BackgroundProcessProgress';

export default {
  name: 'Invoices',
  components: {
    SearchFilter,
    SearchSummary,
    AddManualInvoiceDialog,
    MoreActions,
    BackgroundProcessProgress
  },
  computed: {
    ...mapGetters(['invoices', 'isInBulkPrintingInvoices', 'isInUploadToVersapay']),
    pdfToSageProcessName() {
      return constants.BACKGROUND_PROCESS.PDF_TO_SAGE;
    }
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    },
    getTotalAmount(invoices) {
      const total = invoices.totalAmount;
      if (total < 0) {
        return `(${this.$options.filters.currency(total).replace('-', '')})`;
      }
      return this.$options.filters.currency(total);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
  #invoices-main {
    .invoice-total {
      font-size: 13px !important;
      padding-top: 5px;
      padding-right: 10px;
      span {
        white-space: nowrap;
      }
    }
  }
</style>
